// import React from "react";
import {
  Text,
  Stack,
  HStack,
  Tooltip,
  Icon,
  Progress,
  Flex,
  // Button,
  // IconButton,
} from "@chakra-ui/react";
import {
  primary,
  secondary,
  textSecondary,
  // textPrimary,
  newBorder,
  white,
  whiteAlt,
  // color3,
  color8,
  backgroundLight,
  primaryAlt,
} from "../../../../utils/colors";
import dayjs from "dayjs";
import {
  // TbMailOpenedFilled,
  TbCopy,
  TbDiscount,
  TbEdit,
  // TbMailOff,
  TbMailX,
} from "react-icons/tb";
import { shade } from "polished";
import StatusButtonTreatmentPlan from "../../../../components/buttons/StatusButtonTreatmentPlan";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";
import { FaEnvelope } from "react-icons/fa6";
import { MdLocalHospital } from "react-icons/md";

export const columnsDesktop = (
  translate,
  useThemeColors,
  setPlanId,
  setShowDeleteConfirmation,
  setShowDuplicateModal,
  openSidePanelModalHandler,
  handleSortChange,
  setTreatmentPlanID,
  currencySymbol
) => {
  return [
    {
      Header: () => (
        <Flex onClick={() => handleSortChange("treatmentPlanID")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnID")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "treatmentPlanID",
      disableSortBy: true,
      width: 110,
      Cell: ({ row }) => {
        const { treatmentPlanID } = row.original;

        return (
          <Text
            textAlign="left"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="xs"
            color={textSecondary}
            fontWeight="500"
          >
            {treatmentPlanID}
          </Text>
        );
      },
    },

    {
      Header: () => (
        <Flex onClick={() => handleSortChange("createdAt")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnDate")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "createdAt",
      disableSortBy: true,
      width: 110,
      Cell: ({ row }) => {
        const { createdAt } = row.original;

        const isCurrentYear = dayjs().year() === dayjs(createdAt).year();

        // console.log("row new", row);

        return (
          <Flex align="center">
            <HStack gap={2} mr="0.5rem">
              <Stack gap={0} overflow="hidden">
                {createdAt && (
                  <Text
                    fontSize="0.8rem"
                    color={textSecondary}
                    fontWeight="500"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    isTruncated
                    textTransform="capitalize"
                  >
                    {dayjs(createdAt).format("MMMM D")}
                  </Text>
                )}
                {!isCurrentYear && (
                  <Text
                    fontSize="0.8rem"
                    color={textSecondary}
                    fontWeight="500"
                    isTruncated
                    noOfLines={1}
                    whiteSpace="normal"
                    textAlign="left"
                    overflow="hidden"
                    w="100%"
                    maxWidth="100px"
                  >
                    {dayjs(createdAt).format("YYYY")}
                  </Text>
                )}
              </Stack>
            </HStack>
          </Flex>
        );
      },
    },

    // {
    //   Header: translate("patient.columnDate"),
    //   disableSortBy: false,
    //   accessor: (row) => {
    //     const { createdAt } = row;

    //     console.log("row", row);

    //     const isCurrentYear = dayjs().year() === dayjs(createdAt).year();

    //     return (
    //       <Flex align="center">
    //         <HStack gap={2} mr="0.5rem">
    //           <Stack gap={0} overflow="hidden">
    //             {createdAt && (
    //               <Text
    //                 fontSize="0.8rem"
    //                 color={textSecondary}
    //                 fontWeight="500"
    //                 whiteSpace="nowrap"
    //                 overflow="hidden"
    //                 isTruncated
    //                 textTransform="capitalize"
    //               >
    //                 {dayjs(createdAt).format("MMMM D")}
    //               </Text>
    //             )}
    //             {!isCurrentYear && (
    //               <Text
    //                 fontSize="0.8rem"
    //                 color={textSecondary}
    //                 fontWeight="500"
    //                 isTruncated
    //                 noOfLines={1}
    //                 whiteSpace="normal"
    //                 overflow="hidden"
    //                 w="100%"
    //                 maxWidth="100px"
    //               >
    //                 {dayjs(createdAt).format("YYYY")}
    //               </Text>
    //             )}
    //           </Stack>
    //         </HStack>
    //       </Flex>
    //     );
    //   },
    // },

    // {
    //   Header: () => (
    //     <Flex onClick={() => handleSortChange("coordinator")} h="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text mr={2}>{translate("patient.columnCoordinator")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "coordinator",
    //   disableSortBy: true,
    //   width: 200,
    //   Cell: ({ row }) => {
    //     const { coordinator } = row.original;

    //     const nameAlt = coordinator
    //       ? coordinator.firstName[0] + ". " + coordinator.lastName
    //       : "N/A";

    //     const nameInitials = coordinator
    //       ? coordinator.firstName[0] + coordinator.lastName[0]
    //       : "N/A";

    //     const nameInitialsDots = coordinator
    //       ? coordinator.firstName[0] + "." + coordinator.lastName[0] + "."
    //       : "N/A";

    //     return (
    //       <Flex align="center" h="100%">
    //         <Tooltip
    //           bg={shade(0.3, secondary)}
    //           p="0.5rem 1rem"
    //           borderRadius="1rem"
    //           placement="top"
    //           fontSize="sm"
    //           label={
    //             <Flex align="center">
    //               <Text
    //                 fontSize="13px"
    //                 fontWeight="500"
    //                 color={white}
    //                 whiteSpace="nowrap"
    //                 lineHeight={1}
    //               >
    //                 {coordinator ? nameAlt : "N/A"}
    //               </Text>
    //             </Flex>
    //           }
    //         >
    //           <Flex>
    //             <Flex align="center">
    //               <Flex
    //                 h="1.35rem"
    //                 w="1.35rem"
    //                 align="center"
    //                 justify="center"
    //                 bg={color8}
    //                 color={white}
    //                 borderRadius="50%"
    //                 fontSize="xs"
    //                 fontWeight="500"
    //                 mr="0.25rem"
    //               >
    //                 {coordinator ? nameInitials : "N/A"}
    //               </Flex>
    //               <Text
    //                 fontSize="0.8rem"
    //                 fontWeight="500"
    //                 color={textSecondary}
    //                 maxW="80px"
    //                 isTruncated
    //               >
    //                 {coordinator ? nameAlt : "N/A"}
    //               </Text>
    //             </Flex>
    //           </Flex>
    //         </Tooltip>
    //       </Flex>
    //     );
    //   },
    // },

    // {
    //   Header: translate("patient.columnCoordinator"),
    //   accessor: (row) => {
    //     const { coordinator } = row;

    //     const nameAlt = coordinator
    //       ? coordinator.firstName[0] + "." + coordinator.lastName
    //       : "N/A";

    //     const nameInitials = coordinator
    //       ? coordinator.firstName[0] + coordinator.lastName[0]
    //       : "N/A";

    //     return (
    //       <Flex align="center" h="100%">
    //         <Tooltip
    //           bg={shade(0.3, secondary)}
    //           p="0.5rem 1rem"
    //           borderRadius="1rem"
    //           placement="top"
    //           fontSize="sm"
    //           label={
    //             <Flex align="center">
    //               <Text
    //                 fontSize="13px"
    //                 fontWeight="500"
    //                 color={white}
    //                 whiteSpace="nowrap"
    //                 lineHeight={1}
    //               >
    //                 {coordinator ? nameAlt : "N/A"}
    //               </Text>
    //             </Flex>
    //           }
    //         >
    //           <Flex>
    //             <Flex align="center">
    //               <Flex
    //                 h="1.35rem"
    //                 w="1.35rem"
    //                 align="center"
    //                 justify="center"
    //                 bg={color8}
    //                 color={white}
    //                 borderRadius="50%"
    //                 fontSize="xs"
    //                 fontWeight="500"
    //                 mr="0.25rem"
    //               >
    //                 {coordinator ? nameInitials : "N/A"}
    //               </Flex>
    //               <Text
    //                 fontSize="0.8rem"
    //                 fontWeight="500"
    //                 color={textSecondary}
    //                 maxW="80px"
    //                 isTruncated
    //               >
    //                 {coordinator ? nameAlt : "N/A"}
    //               </Text>
    //             </Flex>
    //           </Flex>
    //         </Tooltip>
    //       </Flex>
    //     );
    //   },
    // },

    {
      Header: () => (
        <Flex onClick={() => handleSortChange("totalPrice")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnServices")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "totalPrice",
      disableSortBy: true,
      width: 200,
      Cell: ({ row }) => {
        const { services } = row.original;

        const { textPrimaryMode } = useThemeColors;

        // console.log("services", services);

        // Count total number of services
        const totalServices = services.length;

        // Count the number of completed services
        const completedServices = services.reduce((acc, service) => {
          return acc + (service.status === "completed" ? 1 : 0);
        }, 0);

        // Calculate the total cost of services
        const servicesTotal = services.reduce((acc, service) => {
          const price = Number(service.discountedPrice || 0);
          const quantity = Number(service.quantity || 0);
          return acc + price * quantity;
        }, 0);

        const hasDiscount = services.some(
          (s) =>
            s.discountedPrice != null &&
            s.discountedPrice < s.price &&
            s.discountType !== "none"
        );

        const isReimbursement = services.some(
          (s) =>
            s.reimbursement &&
            (s.reimbursement.code?.length > 0 ||
              s.reimbursement.reimbursedAmount > 0 ||
              s.reimbursement.type?.length > 0)
        );

        return (
          <Flex align="center" pr={0} borderRight={`0px solid ${newBorder}`}>
            <Stack gap={0} textAlign="left" mr="0.5rem">
              <Text
                fontSize="0.8rem"
                color={textSecondary}
                fontWeight="500"
                mt="6px"
              >
                <Text as="span" color={textPrimaryMode} fontWeight="500">
                  {completedServices}
                </Text>
                /{totalServices}
              </Text>
              <Progress
                className="attendeesTotal"
                w="36px"
                value={(completedServices / totalServices) * 100}
                mt="0.25rem"
                color={primary}
                size="sm"
                height="3px"
                borderRadius="0.5rem"
              />
            </Stack>

            <Flex align="center">
              {hasDiscount && (
                <Flex align="center" justify="center" textAlign="center" mr={0}>
                  <Icon
                    as={TbDiscount}
                    color={primaryAlt}
                    fontSize="0.875rem"
                    mr="0.125rem"
                    position="relative"
                    top="-1px"
                  />
                </Flex>
              )}

              {isReimbursement && (
                <Flex align="center" justify="center" textAlign="center" mr={0}>
                  <Icon
                    as={MdLocalHospital}
                    color={primaryAlt}
                    fontSize="0.875rem"
                    mr="0.125rem"
                    position="relative"
                    top="-1px"
                  />
                </Flex>
              )}
              <Text
                fontSize="0.8rem"
                color={textSecondary}
                fontWeight="500"
                whiteSpace="nowrap"
              >
                {currencySymbol} {servicesTotal.toFixed(2)}
              </Text>
            </Flex>
          </Flex>
        );
      },
    },

    // {
    //   Header: translate("patient.columnServices"),
    //   disableSortBy: false,
    //   accessor: (row) => {
    //     const { services } = row;

    //     const { textPrimaryMode } = useThemeColors;

    //     // console.log("services", services);

    //     // Count total number of services
    //     const totalServices = services.length;

    //     // Count the number of completed services
    //     const completedServices = services.reduce((acc, service) => {
    //       return acc + (service.status === "completed" ? 1 : 0);
    //     }, 0);

    //     // Calculate the total cost of services
    //     const servicesTotal = services.reduce((acc, service) => {
    //       const price = Number(service.price || 0);
    //       const quantity = Number(service.quantity || 0);
    //       return acc + price * quantity;
    //     }, 0);

    //     return (
    //       <Flex align="center" pr={0} borderRight={`0px solid ${newBorder}`}>
    //         {/* <Icon as={TbMessageCircle} fontSize="lg" color="#989EA7" /> */}
    //         <Stack gap={0} textAlign="left" mr="0.5rem">
    //           <Text
    //             fontSize="0.8rem"
    //             color={textSecondary}
    //             fontWeight="500"
    //             mt="6px"
    //           >
    //             <Text as="span" color={textPrimaryMode} fontWeight="500">
    //               {completedServices}
    //             </Text>
    //             /{totalServices}
    //           </Text>
    //           <Progress
    //             className="attendeesTotal"
    //             w="36px"
    //             value={(completedServices / totalServices) * 100}
    //             mt="0.25rem"
    //             color={primary}
    //             size="sm"
    //             height="3px"
    //             borderRadius="0.5rem"
    //           />
    //         </Stack>
    //         {/* <Flex align="center" justify="center">
    //           <Text
    //             fontSize="0.8rem"
    //             color={textSecondary}
    //             opacity="0.6"
    //             fontWeight="500"
    //             ml={0}
    //             mr={1}
    //           >
    //             |
    //           </Text>
    //         </Flex> */}

    //         <Text
    //           fontSize="0.8rem"
    //           color={textSecondary}
    //           fontWeight="500"
    //           whiteSpace="nowrap"
    //         >
    //           {servicesTotal.toFixed(2)} €
    //         </Text>
    //       </Flex>
    //     );
    //   },
    // },

    {
      Header: () => (
        <Flex onClick={() => handleSortChange("status")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      // width: 260,
      Cell: ({ row }) => {
        const {
          status,
          _id,
          treatmentPlanID,
          cancelledFromSharedLink,
          cancelledFromSharedLinkDate,
          cancelledReason,
          cancelledComment,
          publicEmailDate,
          availablePublic,
          emailSentBy,
          emailSentByName,
          emailSentByEmail,
          approvedFromSharedLinkDate,
          approvedFromSharedLink,
        } = row.original;

        // console.log("row", row.original);

        let cancelledBy = "-";

        if (cancelledFromSharedLink === true) {
          cancelledBy = translate("patient.patient");
        } else {
          cancelledBy = translate("employee.employee");
        }

        // console.log("row", row.original);

        return (
          <HStack gap={0} justify="flex-end">
            {availablePublic && publicEmailDate !== null ? (
              <Tooltip
                p="0.5rem 1rem"
                borderRadius="1rem"
                placement="top"
                label={
                  <Flex direction="column">
                    <Flex align="center" gap="0.25rem">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                      >
                        {translate("treatmentPlan.emailSentToPatient")}:
                      </Text>
                      <Text
                        fontSize="xs"
                        color={white}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                        textTransform="capitalize"
                      >
                        {dayjs(publicEmailDate).format("YYYY MMMM D, HH:mm")}
                      </Text>
                    </Flex>
                    <Flex align="center" gap="0.25rem">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                      >
                        {translate("treatmentPlan.emailSentToPatientBy")}:
                      </Text>
                      <Text
                        fontSize="xs"
                        color={white}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                        isTruncated
                        maxW="220px"
                      >
                        {emailSentByName}, {emailSentByEmail}
                        {/* {emailSentBy &&
                          emailSentBy.lastName &&
                          emailSentBy.lastName}{" "}
                        {emailSentBy && emailSentBy.firstName} */}
                      </Text>
                    </Flex>
                  </Flex>
                }
              >
                <Flex
                  bg={color8}
                  align="center"
                  justify="center"
                  w="1.25rem"
                  h="1.25rem"
                  borderRadius="10rem"
                  mr="0.75rem"
                  flexShrink={0}
                >
                  <Icon as={FaEnvelope} fontSize="0.6rem" color={white} />
                </Flex>
              </Tooltip>
            ) : (
              <Flex
                bg={backgroundLight}
                align="center"
                justify="center"
                w="1.25rem"
                h="1.25rem"
                borderRadius="10rem"
                mr="0.75rem"
              >
                <Icon as={TbMailX} fontSize="0.8rem" color={textSecondary} />
              </Flex>
            )}

            <StatusButtonTreatmentPlan
              isUnclickable
              isSmall
              currentStatus={status}
              onUpdateStatus={() => {}}
              options="treatment"
              isTooltip={
                status === "cancelled"
                // || status === "approved"
              }
              tooltipLabel={
                <Stack gap={0} align="flex-start">
                  {status === "cancelled" && (
                    <Flex align="center" justify="center">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        mr={1}
                      >
                        {translate("reason.cancelledBy")}:
                      </Text>
                      <Text
                        isExternal
                        color={white}
                        fontWeight="500"
                        fontSize="xs"
                        isTruncated
                        maxW="128px"
                      >
                        {cancelledBy}
                      </Text>
                    </Flex>
                  )}

                  {/* {status === "approved" &&
                    approvedFromSharedLinkDate !== null && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.approvedBy")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="160px"
                          textTransform="capitalize"
                        >
                          {approvedFromSharedLink === true
                            ? translate("patient.patient")
                            : translate("employee.employee")}
                        </Text>
                      </Flex>
                    )} */}

                  {/* {status === "approved" &&
                    approvedFromSharedLink === false &&
                    approvedFromSharedLinkDate !== null && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.approvedAt")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="160px"
                          textTransform="capitalize"
                        >
                          {dayjs(cancelledFromSharedLinkDate).format(
                            "MMMM D, YYYY, HH:mm"
                          )}
                        </Text>
                      </Flex>
                    )} */}

                  {status === "cancelled" &&
                    cancelledFromSharedLinkDate !== null && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledAt")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="160px"
                          textTransform="capitalize"
                        >
                          {dayjs(cancelledFromSharedLinkDate).format(
                            "MMMM D, YYYY, HH:mm"
                          )}
                        </Text>
                      </Flex>
                    )}

                  {status === "cancelled" &&
                    cancelledReason &&
                    cancelledReason.length > 0 && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledReason")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="128px"
                        >
                          {translate(`reason.${cancelledReason}`)}
                        </Text>
                      </Flex>
                    )}

                  {status === "cancelled" &&
                    cancelledComment &&
                    cancelledComment.length > 0 && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledComment")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="13px"
                          isTruncated
                          maxW="128px"
                        >
                          {cancelledComment}
                        </Text>
                      </Flex>
                    )}
                </Stack>
              }
            />

            <MoreButtonLite
              id={_id}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setPlanId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setTreatmentPlanID(treatmentPlanID);
              }}
              viewHandler={() => {
                openSidePanelModalHandler(_id);
              }}
              viewLabel={translate("treatmentPlan.editPlan")}
              viewIcon={TbEdit}
              editHandler={() => {
                setPlanId(_id);
                setShowDuplicateModal(true);
                setTreatmentPlanID(treatmentPlanID);
              }}
              editLabel={translate("treatmentPlan.duplicateTreatmentPlan")}
              editId={_id}
              editIcon={TbCopy}
              isSmall
            />
          </HStack>
        );
      },
    },

    // {
    //   Header: () => (
    //     <Flex w="100%" h="100%">
    //       <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
    //         <Text mr={2}>{translate("patient.columnStatus")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "status",
    //   Cell: ({ row }) => {
    //     const {
    //       status,
    //       _id,

    //       cancelledFromSharedLink,
    //       cancelledFromSharedLinkDate,
    //       cancelledReason,
    //       cancelledComment,
    //       publicEmailDate,
    //       availablePublic,
    //       emailSentBy,
    //     } = row.original;

    //     // console.log("row", row.original);

    //     let cancelledBy = "-";

    //     if (cancelledFromSharedLink === true) {
    //       cancelledBy = translate("patient.patient");
    //     } else {
    //       cancelledBy = translate("employee.employee");
    //     }

    //     // console.log("row", row.original);

    //     return (
    //       <HStack gap={0} justify="flex-end">
    //         {availablePublic && publicEmailDate !== null ? (
    //           <Tooltip
    //             p="0.5rem 1rem"
    //             borderRadius="1rem"
    //             placement="top"
    //             label={
    //               <Flex direction="column">
    //                 <Flex align="center" gap="0.25rem">
    //                   <Text
    //                     fontSize="xs"
    //                     color={whiteAlt}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     whiteSpace="nowrap"
    //                   >
    //                     {translate("treatmentPlan.emailSentToPatient")}:
    //                   </Text>
    //                   <Text
    //                     fontSize="xs"
    //                     color={white}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     whiteSpace="nowrap"
    //                     textTransform="capitalize"
    //                   >
    //                     {dayjs(publicEmailDate).format("YYYY MMMM D, HH:mm")}
    //                   </Text>
    //                 </Flex>
    //                 <Flex align="center" gap="0.25rem">
    //                   <Text
    //                     fontSize="xs"
    //                     color={whiteAlt}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     whiteSpace="nowrap"
    //                   >
    //                     {translate("treatmentPlan.emailSentToPatientBy")}:
    //                   </Text>
    //                   <Text
    //                     fontSize="xs"
    //                     color={white}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     whiteSpace="nowrap"
    //                     isTruncated
    //                     maxW="220px"
    //                   >
    //                     {emailSentBy &&
    //                       emailSentBy.lastName &&
    //                       emailSentBy.lastName}{" "}
    //                     {emailSentBy && emailSentBy.firstName}
    //                   </Text>
    //                 </Flex>
    //               </Flex>
    //             }
    //           >
    //             <Button
    //               size="sm"
    //               // h="2.25rem"
    //               fontSize="sm"
    //               bg="transparent"
    //               color={textSecondary}
    //               borderRadius="0.875rem"
    //               mr="0.25rem"
    //               // onClick={handleOpenSendEmailModal(_id)}
    //               _hover={{
    //                 bg: "transparent",
    //                 color: textPrimary,
    //               }}
    //             >
    //               <Icon
    //                 as={TbMailOpenedFilled}
    //                 fontSize="1rem"
    //                 color={color3}
    //                 opacity="0.8"
    //               />
    //             </Button>
    //           </Tooltip>
    //         ) : (
    //           <Tooltip
    //             p="0.5rem 1rem"
    //             borderRadius="1rem"
    //             placement="top"
    //             isDisabled
    //             label={
    //               <Flex direction="column">
    //                 <Flex align="center" gap="0.25rem">
    //                   <Text
    //                     fontSize="xs"
    //                     color={whiteAlt}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     whiteSpace="nowrap"
    //                   >
    //                     {translate("treatmentPlan.sendEmailToPatient")}
    //                   </Text>
    //                 </Flex>
    //               </Flex>
    //             }
    //           >
    //             <IconButton
    //               size="sm"
    //               // h="2.25rem"
    //               fontSize="sm"
    //               // bg={backgroundLight}
    //               bg="transparent"
    //               // border={`1px solid ${newBorder}`}
    //               color={textSecondary}
    //               borderRadius="10rem"
    //               mr="0.4rem"
    //               // onClick={handleOpenSendEmailModal(_id)}
    //               _hover={{
    //                 // bg: primaryAlt,
    //                 // color: white,
    //                 bg: "transparent",
    //                 color: textSecondary,
    //               }}
    //             >
    //               {/* <Icon as={TbMailCancel} fontSize="0.875rem" /> */}
    //             </IconButton>
    //           </Tooltip>
    //         )}

    //         <StatusButtonTreatmentPlan
    //           isUnclickable
    //           isSmall
    //           currentStatus={status}
    //           onUpdateStatus={() => {}}
    //           options="treatment"
    //           isTooltip={status === "cancelled"}
    //           tooltipLabel={
    //             <Stack gap={1} align="flex-start">
    //               <Flex align="center" justify="center">
    //                 <Text
    //                   fontSize="xs"
    //                   color={tint(0.6, secondary)}
    //                   fontWeight="500"
    //                   textAlign="center"
    //                   mr={1}
    //                 >
    //                   {translate("reason.cancelledBy")}:
    //                 </Text>
    //                 <Text
    //                   isExternal
    //                   color={white}
    //                   fontWeight="500"
    //                   fontSize="13px"
    //                   isTruncated
    //                   maxW="128px"
    //                 >
    //                   {cancelledBy}
    //                 </Text>
    //               </Flex>

    //               {cancelledFromSharedLinkDate !== null && (
    //                 <Flex align="center" justify="center">
    //                   <Text
    //                     fontSize="xs"
    //                     color={tint(0.6, secondary)}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     mr={1}
    //                   >
    //                     {translate("reason.cancelledAt")}:
    //                   </Text>
    //                   <Text
    //                     color={white}
    //                     fontWeight="500"
    //                     fontSize="13px"
    //                     isTruncated
    //                     maxW="128px"
    //                     textTransform="capitalize"
    //                   >
    //                     {dayjs(cancelledFromSharedLinkDate).format(
    //                       "MMMM D, YYYY, HH:mm"
    //                     )}
    //                   </Text>
    //                 </Flex>
    //               )}

    //               {cancelledReason && cancelledReason.length > 0 && (
    //                 <Flex align="center" justify="center">
    //                   <Text
    //                     fontSize="xs"
    //                     color={tint(0.6, secondary)}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     mr={1}
    //                   >
    //                     {translate("reason.cancelledReason")}:
    //                   </Text>
    //                   <Text
    //                     color={white}
    //                     fontWeight="500"
    //                     fontSize="13px"
    //                     isTruncated
    //                     maxW="128px"
    //                   >
    //                     {translate(`reason.${cancelledReason}`)}
    //                   </Text>
    //                 </Flex>
    //               )}

    //               {cancelledComment && cancelledComment.length > 0 && (
    //                 <Flex align="center" justify="center">
    //                   <Text
    //                     fontSize="xs"
    //                     color={tint(0.6, secondary)}
    //                     fontWeight="500"
    //                     textAlign="center"
    //                     mr={1}
    //                   >
    //                     {translate("reason.cancelledComment")}:
    //                   </Text>
    //                   <Text
    //                     color={white}
    //                     fontWeight="500"
    //                     fontSize="13px"
    //                     isTruncated
    //                     maxW="128px"
    //                   >
    //                     {cancelledComment}
    //                   </Text>
    //                 </Flex>
    //               )}
    //             </Stack>
    //           }
    //         />

    //         <MoreButtonLite
    //           id={_id}
    //           deleteHandler={true}
    //           setShowDeleteConfirmation={() => {
    //             setPlanId(_id); // Set the user ID for deletion
    //             setShowDeleteConfirmation(true); // Open confirmation modal
    //             // setPatientName(
    //             //   row.original.lastName + " " + row.original.firstName
    //             // );
    //           }}
    //           viewHandler={() => {
    //             openSidePanelModalHandler(_id);
    //           }}
    //           viewLabel={translate("treatmentPlan.editPlan")}
    //           viewIcon={TbEdit}
    //           editHandler={() => {}}
    //           editLabel={translate("treatmentPlan.duplicateTreatmentPlan")}
    //           editId={_id}
    //           editIcon={TbCopy}
    //           isSmall
    //         />
    //       </HStack>
    //     );
    //   },
    // },
  ];
};
